import React from 'react';

// Checkbox list of the fixed PD catalog. `checkedIds` is the Set of currently
// enabled pi_parameter_ids; toggling flips membership; Save persists via
// setSystemParameters. No free-form definitions — the catalog is fixed.
export function PISystemParametersTab({
  parameters,
  checkedIds,
  onToggle,
  onSave,
  loading,
  error,
}) {
  return (
    <div className="pi-parameters-tab">
      {error && <div className="error-message" role="alert">{error}</div>}

      <p>Select which catalog parameters this PI System captures.</p>

      <div className="parameter-checkboxes">
        {parameters.map((param) => (
          <label key={param.id} className="checkbox-item">
            <input
              type="checkbox"
              checked={checkedIds.has(param.id)}
              onChange={() => onToggle(param.id)}
              disabled={loading}
            />
            <span>{param.name}</span>
            <span className="parameter-unit">({param.unit})</span>
          </label>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button
          type="button"
          className="btn-primary"
          onClick={onSave}
          disabled={loading}
        >
          Save Parameters
        </button>
      </div>
    </div>
  );
}
